import { useNavigate } from 'react-router-dom';
import formatFileCategory from '../../../../core/commom/formatFileCategory';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import {
  IconDone,
  IconFav,
} from '../../../../core/components/organism/ContentCard/variants';
import { Tag } from '../../../../core/components/atoms/Tag';
import { Colors } from '../../../../core/models/disciplines';
import { IResponseFavorite, useContentFavorite } from '../../hooks/useContentFavorite';

interface IMaterialCard {
  material: any;
  discipline: string;
  module: string;
  subjectSlug: string;
  subject: string;
  slug: string;
  done: boolean;
  favorite: boolean;
  onClose: () => void;
  callback: (data: IResponseFavorite) => void;
  onDone?: (id: string, slug: string) => void;
  locked?: boolean;
  onLockedClick?: () => void;
}

function MaterialCard({
  material,
  discipline,
  module,
  subject,
  subjectSlug,
  slug,
  done,
  favorite,
  onClose,
  callback,
  onDone,
  locked = false,
  onLockedClick,
}: IMaterialCard) {
  const navigate = useNavigate();
  const { mutate, isLoading } = useContentFavorite(true, callback);

  const selected = material.slug === slug;
  const selectedBorder = selected
    ? 'border-hairline border-brand-color-primary-pure'
    : null;
  const replacementLink = `/disciplinas/${discipline}/modulo/${module}/assunto/${subjectSlug}/material/${material.slug}`;

  const onFavorite = () => {
    const content = material.file_category;

    if (
      content === 'materiais' ||
      content === 'workbook' ||
      content === 'Material'  ||
      content === 'apostila'
    ) {
      mutate({
        category: 'apostila',
        targetId: material._id,
        targetType: 'Material',
      });
    }

    if (content === 'mindmap' || content === 'mapa_mental') {
      mutate({
        category: 'mapamental',
        targetId: material._id,
        targetType: 'Material',
      });
    }

    if (content === 'podcast' || content === 'Podcast') {
      mutate({
        category: 'audio',
        targetId: material._id,
        targetType: 'Material',
      });
    }
  }

  return (
    <div
      key={material._id}
      className={'flex cursor-pointer rounded-md bg-color-lightest p-4 shadow-level-1 '+selectedBorder}
    >
      <div
        className='flex flex-1 flex-col gap-sm'
        onClick={() => {
          if (locked) {
            onLockedClick?.();
            return;
          }
          if (!selected) {
            onClose();
            navigate(replacementLink);
          }
        }}
      >
        <div className='flex flex-row justify-between items-center'>
          <div className='flex items-center gap-sm'>
            <Icon
              Icon='library_books'
              type='material'
              className='text-md text-brand-color-secondary-pure'
            />
            <Typography size='h6' weight='bold' type='titleSection'>
              MATERIAL
            </Typography>
          </div>
          {subject && (
            <Tag
              variant={discipline as Colors}
              className='flex flex-row items-center gap-sm px-2 mr-3'
            >
              <Typography size='small' className='text-[#fff]'>
                {subject}
              </Typography>
            </Tag>
          )}
        </div>

        <Typography type='title' weight='bold'>
          {material.title}
        </Typography>
        <Typography size='small'>
          {formatFileCategory(material.file_category)}
        </Typography>
      </div>
      {locked ? (
        <div className='flex w-fit flex-col items-center justify-center'>
          <Icon
            id='lock-icon'
            Icon='lock'
            variant='rounded'
            type='material'
            className='text-xxl filled text-mono-color-medium'
          />
        </div>
      ) : (
        <div className='flex w-fit flex-col items-end justify-between'>
          <Icon
            Icon='check_circle'
            type='material'
            className={IconDone({ type: done ? 'done' : 'unseen' })}
            onClick={() => onDone && onDone(material._id, material.slug)}
          />
          <Button
            onlyIcon
            variant='text'
            size='regular'
            className='px-0 py-0'
            loading={isLoading}
            onClick={() => onFavorite()}
          >
            <Icon
              Icon='star'
              type='material'
              variant='rounded'
              className={IconFav({ type: favorite ? 'favorite' : 'notFavorite' })}
            />
          </Button>
        </div>
      )}
    </div>
  );
}

export default MaterialCard;
